import React, { useState } from 'react';
import { useMutation } from 'react-fetching-library';
import { useHistory } from 'react-router';
import { Snackbar } from '@material-ui/core';

import { useLoginForInstitution } from 'api/actions/login/login.actions';
import { StudentLoginInstitutionForm } from './studentLoginInstitutionForm';
import { handleOnSubmit } from 'shared/utils/handleOnSubmit/handleOnSubmit';
import { AppRoute } from 'app/routing/AppRoute.enum';
import { LoginResponse } from 'api/actions/login/login.types';
import { useStyles } from './studentLoginInstitutionForm.styles';
import { useUpdateParticipantQueryData } from 'contexts/participantQueryData/participantQueryDataContext';
import { InstitutionEventDataResponse } from 'api/actions/selfRegistration/selfRegistration.types';

export const StudentLoginInstitutionFormContainer = ({
  instituitionEventDetails,
}: {
  instituitionEventDetails: InstitutionEventDataResponse;
}) => {
  const { mutate } = useMutation(useLoginForInstitution);
  const { push } = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');
  const styles = useStyles();

  const updateParticipantQueryData = useUpdateParticipantQueryData();

  const handleSuccessCallback = (value: LoginResponse) => {
    if (value.isParticipantFound) {
      updateParticipantQueryData({
        participantId: value.participantId,
        secret: value.token,
        editToken: value.editToken,
        edit: true,
      });
      push({
        pathname: AppRoute.studentNameListenerEdit,
        state: { isFromInstitution: true },
      });
    } else if (value.message) {
      setIsOpen(true);
      setMessage(value?.message);
    }
    setIsOpen(true);
  };

  const onSubmit = handleOnSubmit({
    action: values => {
      // remove year from the values before sending to mutate
      const { year, ...rest } = values;

      return mutate(rest);
    },
    successCallback: value => handleSuccessCallback(value),
  });

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <StudentLoginInstitutionForm onSubmit={onSubmit} instituitionEventDetails={instituitionEventDetails} />
      <Snackbar
        open={isOpen}
        onClose={handleClose}
        autoHideDuration={3000}
        message={`${message || `Try using the email address you received this link at`}`}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        className={styles.snackBar}
      />
    </>
  );
};
